import { Agent, LicensePageQuery, LicenseQuery } from '@/graphql/codegen/generated/graphql';
import { Constants } from '../../const/globals';
import { licenseValidators, isRuleListNotInLicenseList } from './licenseValidators';

const isBuildAvoidanceLicensed = (license: NonNullable<NonNullable<LicenseQuery['license']>['windows']>['summary'] | NonNullable<LicensePageQuery['ibManagerEntities']>['license']) => {
  const rules = [{ totalBuildCacheCores: ['>', 0] }];
  const validator = licenseValidators(rules, license);
  return validator;
};

const isDashboardLicensed = (license: NonNullable<NonNullable<LicenseQuery['license']>['windows']>['features']) => {
  const rules = [{ productFeatures: [Constants?.LICENSE_FEATURES?.DASHBOARD] }];
  const validator = licenseValidators(rules, license);
  return validator;
};

const showAllowCustomDistributionProfiles = (license: NonNullable<NonNullable<LicenseQuery['license']>['windows']>['features']) => {
  const buildToolsRule = [{ addonFeatures: Constants?.LICENSE_FEATURES?.SETTINGS?.GENERAL?.ALLOW_CUSTOM_DISTRIBUTION_PROFILES.ALLOWED[0] }];
  const VSCRule = [{ addonFeatures: Constants?.LICENSE_FEATURES?.SETTINGS?.GENERAL?.ALLOW_CUSTOM_DISTRIBUTION_PROFILES.ALLOWED[1] }];
  const validatorForBuildTools = licenseValidators(buildToolsRule, license);
  const validatorForVSC = licenseValidators(VSCRule, license);
  return (
    validatorForBuildTools && validatorForVSC && isRuleListNotInLicenseList('addonFeatures', Constants?.LICENSE_FEATURES?.SETTINGS?.GENERAL?.ALLOW_CUSTOM_DISTRIBUTION_PROFILES.NOT_ALLOWED, license)
  );
};

const isBuildAvoidanceAgent = (agentLicense: Agent['license']) =>
  // todo implement || (OR) operator in licenseValidators
  agentLicense?.initiatorType === 'Fixed' || agentLicense?.initiatorType === 'Floating' || agentLicense?.ciInitiatorType === 'Fixed' || agentLicense?.ciInitiatorType === 'Floating';
export { isBuildAvoidanceLicensed, isBuildAvoidanceAgent, isDashboardLicensed, showAllowCustomDistributionProfiles };
